import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

const SkeletonLoader = ({
  index,
  type,
  sidebars,
  details,
  length,
  pageName,
  uId,
}) => {
  const masterData = useSelector((state) => state?.masterData);
  const postsDetails = useSelector((state) => state?.postsDetails?.[pageName]);
  const isSmallScreen = useMediaQuery({ maxWidth: 991 });
  const [skeletonType, setSkeletonType] = useState("");
  useEffect(() => {
    setSkeletonType(type);
  }, [type]);

  return (
    <div className="d-flex justify-content-center" key={index}>
      {skeletonType === "newsletter-side" ? (
        <div
          className="d-flex align-items-center w-100 flex-column justify-content-center mb-2"
          style={{
            minHeight: "225px",
            boxShadow:
              "rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
            padding: "15px",
          }}
        >
          <Skeleton
            style={{ width: "100px", height: "25px", marginBottom: "10px" }}
          />
          <Skeleton
            circle
            width="50px"
            height="50px"
            style={{ marginBottom: "10px" }}
          />
          <Skeleton height={"50px"} containerClassName="w-100" />
        </div>
      ) : skeletonType === "deadlines-list-side" ? (
        <div
          className="d-flex align-items-center flex-column justify-content-center mb-2"
          style={{
            minHeight: "340px",
            border: "solid 1px #e6e6e6",
            padding: "15px",
          }}
        >
          <Skeleton
            style={{
              height: "40px",
              marginBottom: "10px",
            }}
            containerClassName="w-100"
          />
          <Skeleton
            style={{ height: "35px", marginBottom: "10px" }}
            containerClassName="w-100"
          />
          <div className="d-flex flex-wrap justify-content-start align-items-center ">
            {new Array(30).fill("").map((iem, index) => {
              return (
                <div
                  style={{ flex: "0 0 calc(100% / 7)" }}
                  className="d-flex justify-content-center align-items-center"
                >
                  <Skeleton
                    key={index}
                    style={{ width: "30px", height: "30px" }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ) : skeletonType === "category-list" || skeletonType === "group-list" ? (
        <div className="d-flex align-items-center flex-column justify-content-center w-100 mb-2">
          <div style={{ height: "44px" }} className="w-100">
            <Skeleton containerClassName="w-100" height={"25px"} />
          </div>
          <Skeleton
            style={{ height: "50px" }}
            count={
              type === "category-list"
                ? masterData?.[pageName]?.categories?.masterData?.length >=
                  details?.maximum_number_of_data
                  ? details?.maximum_number_of_data
                  : masterData?.[pageName]?.categories?.masterData?.length || 4
                : type === "group-list"
                ? masterData?.[pageName]?.groups?.masterData?.length >=
                  details?.maximum_number_of_data
                  ? details?.maximum_number_of_data
                  : masterData?.[pageName]?.groups?.masterData?.length || 4
                : 4
            }
            containerClassName="w-100"
          />
        </div>
      ) : skeletonType === "post-list-side" ||
        skeletonType === "event-list-side" ||
        skeletonType === "course-list-side" ? (
        <div
          className="d-flex align-items-center flex-column justify-content-center w-100 mb-2"
          style={{
            padding: "10px 0 10px 0",
          }}
        >
          {details?.display_header === 1 && (
            <div style={{ height: "44px" }} className="w-100">
              <Skeleton containerClassName="w-100" height={"25px"} />
            </div>
          )}
          <div className="d-flex justify-content-center flex-column w-100 align-items-center">
            {new Array(
              (postsDetails?.[uId]?.posts?.[1] &&
              Object.values(postsDetails?.[uId]?.posts?.[1])?.length >= 5
                ? 5
                : postsDetails?.[uId]?.posts?.[1] &&
                  Object.values(postsDetails?.[uId]?.posts?.[1])?.length) || 5
            )
              .fill("")
              .map((item, index) => {
                return (
                  <div key={index} className="w-100 pb-1">
                    <div className="d-flex ">
                      <div className="pe-3">
                        <Skeleton width={"120px"} height={"60px"} />
                      </div>
                      <div className="d-flex w-100 flex-column">
                        <Skeleton width={"100px"} height={"15px"} />
                        <Skeleton containerClassName="w-100" height={"35px"} />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      ) : skeletonType === "tag-list" ? (
        <div
          className="d-flex align-items-start flex-wrap justify-content-start mb-2"
          style={{
            padding: "10px 0 10px 0",
            width: "300px",
          }}
        >
          <div style={{ height: "44px" }} className="w-100">
            <Skeleton containerClassName="w-100" height={"25px"} />
          </div>
          {new Array(
            masterData?.[pageName]?.tags?.masterData?.length >=
            details?.maximum_number_of_data
              ? details?.maximum_number_of_data
              : masterData?.[pageName]?.tags?.masterData?.length || 5
          )
            .fill(5)
            .map((item, index) => {
              return (
                <Skeleton
                  key={index}
                  style={{
                    width: "80px",
                    height: "40px",
                    marginBottom: "10px",
                    marginRight: "10px",
                  }}
                />
              );
            })}
        </div>
      ) : skeletonType === "banner" ? (
        <div
          className="d-flex flex-column justify-content-center w-100 align-items-center"
          style={{
            border: "solid 1px #e6e6e6",
            marginBottom: "10px",
            aspectRatio: "16/9",
          }}
        >
          <Skeleton
            width={"250px"}
            height={"30px"}
            style={{ marginBottom: "15px" }}
          />
          <Skeleton width={"350px"} height={"30px"} />
        </div>
      ) : skeletonType === "carousel" ? (
        <div
          className={`${
            (sidebars && sidebars?.length === 0) || isSmallScreen
              ? "container mb-2"
              : "row p-0 col-12"
          }`}
        >
          <div className="col-lg-12 p-0">
            <div className="w-100">
              <div
                className="d-flex flex-column w-100 gap-10"
                style={{
                  height: "100%",
                  marginBottom: "10px",
                }}
              >
                {details?.display_header === 1 && (
                  <div style={{ height: "74px" }}>
                    <Skeleton height={"40px"} containerClassName="w-100" />
                    <Skeleton
                      height={"10px"}
                      containerClassName="w-100"
                      style={{ marginBottom: "10px" }}
                    />
                  </div>
                )}
                <div
                  className="d-flex flex-row mb-2"
                  style={{
                    height: "100%",
                  }}
                >
                  <div className="w-100 d-flex flex-column pe-2">
                    <div
                      style={{
                        aspectRatio: "16/9",
                        width: "100%",
                        height: "100%",
                      }}
                      className="mb-2"
                    >
                      <Skeleton
                        height={"100%"}
                        containerClassName="w-100 mb-2"
                      />
                    </div>

                    <div>
                      <Skeleton
                        width={"150px"}
                        height={"30px"}
                        style={{ marginBottom: "5px" }}
                      />
                      <Skeleton containerClassName="w-100" height={"48px"} />
                    </div>
                  </div>
                  {sidebars && sidebars?.length !== 0 && !isSmallScreen && (
                    <div className="w-100 d-flex flex-column ps-2">
                      <div
                        style={{
                          aspectRatio: "16/9",
                          width: "100%",
                          height: "100%",
                        }}
                        className="mb-2"
                      >
                        <Skeleton
                          height={"100%"}
                          containerClassName="w-100 mb-2"
                        />
                      </div>
                      <div>
                        <Skeleton
                          width={"150px"}
                          height={"30px"}
                          style={{ marginBottom: "5px" }}
                        />
                        <Skeleton containerClassName="w-100" height={"48px"} />
                      </div>
                    </div>
                  )}
                </div>
                {details?.display_header === 0 && sidebars?.length !== 0 && (
                  <div
                    style={{ height: "45px" }}
                    className="d-flex gap-2 align-items-center justify-content-center"
                  >
                    <Skeleton height={"12px"} width={"12px"} circle />
                    <Skeleton height={"12px"} width={"12px"} circle />
                    <Skeleton height={"12px"} width={"12px"} circle />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : skeletonType === "newsletter" ? (
        <div className="container p-0">
          <div
            style={{
              boxShadow:
                "rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
              height: "130px",
              minHeight: "130px",
              marginBottom: "30px",
            }}
            className="d-flex justify-content-between align-items-center w-100"
          >
            <div className="flex-1 d-flex justify-content-center align-items-center w-100">
              <Skeleton width={"80px"} height={"30px"} />
            </div>
            <div className="flex-1 d-flex gap-4 justify-content-center align-items-center w-100">
              <Skeleton circle height={"40px"} width={"40px"} />
              <Skeleton height={"40px"} width={"120px"} />
            </div>
          </div>
        </div>
      ) : skeletonType === "scroller" ? (
        <div
          className="container"
          style={{
            padding: sidebars && sidebars.length === 0 ? "0 28px" : "0",
          }}
        >
          <div
            style={{
              height: "70px",
              marginBottom: "10px",
            }}
            className="d-flex align-items-center w-100 justify-content-between"
          >
            <div
              style={{ width: "141px", border: "1px solid lightgray" }}
              className="d-flex justify-content-center align-items-center h-100"
            >
              <Skeleton width={"80px"} height={"25px"} />
            </div>
            <div className="d-flex gap-2 align-items-center justify-content-start">
              <Skeleton height={"45px"} width={"80px"} />
              <div className="d-flex flex-column gap-1">
                <Skeleton width={"250px"} height={"20px"} />
                <Skeleton width={"90px"} height={"25px"} />
              </div>
            </div>
            <div style={{ width: "91px" }}>
              <Skeleton height={"70px"} containerClassName="w-100" />
            </div>
          </div>
        </div>
      ) : skeletonType === "trendingPosts" ? (
        <div
          className="container"
          style={{
            borderBottom: "1px solid #eee",
          }}
        >
          <div
            style={{
              height: "93px",
              marginBottom: "5px",
            }}
            className="d-flex align-items-center w-100 justify-content-between gap-3"
          >
            <div
              style={{ width: "156px" }}
              className="d-flex justify-content-center align-items-center h-100"
            >
              <Skeleton containerClassName="w-100" height={"48px"} />
            </div>
            <div className="w-100">
              <Skeleton height={"35px"} containerClassName="w-100" />
            </div>
            <div style={{ width: "60px" }}>
              <Skeleton height={"48px"} containerClassName="w-100" />
            </div>
          </div>
        </div>
      ) : skeletonType === "lists" ? (
        <div
          className="container"
          style={{
            borderBottom: "1px solid #eee",
          }}
        >
          <div
            style={{
              height: "98px",
              marginBottom: "5px",
            }}
            className="d-flex align-items-center w-100 justify-content-between gap-3"
          >
            <div
              style={{ width: "156px" }}
              className="d-flex justify-content-center align-items-center h-100"
            >
              <Skeleton containerClassName="w-100" height={"48px"} />
            </div>
            <div className="w-100">
              <Skeleton height={"35px"} containerClassName="w-100" />
            </div>
            <div style={{ width: "60px" }}>
              <Skeleton height={"48px"} containerClassName="w-100" />
            </div>
          </div>
        </div>
      ) : skeletonType === "list" ? (
        <div className="container mb-5 p-0">
          <div className="w-100">
            {details?.display_header === 1 && (
              <div className="w-100 mb-2">
                <Skeleton height="35px" containerClassName="w-100" />
              </div>
            )}
            {details?.search_bar === 1 && (
              <div className="w-100 mb-2">
                <Skeleton height="45px" containerClassName="w-100" />
              </div>
            )}
            <div className="d-flex flex-column gap-2">
              {new Array(
                details?.pagination && length >= details?.items_per_page
                  ? details?.items_per_page
                  : length || 2
              )
                .fill("")
                .map((item, index) => {
                  return (
                    <div className="container p-0 d-flex align-items-center gap-3">
                      <div className="col-12 row">
                        <div className="col-5">
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              aspectRatio: "16/9",
                            }}
                          >
                            <Skeleton
                              containerClassName="w-100"
                              height={"100%"}
                            />
                          </div>
                        </div>
                        <div className="col-7 my-auto">
                          <div className="d-flex flex-column gap-2">
                            <Skeleton
                              width={
                                sidebars && sidebars?.length === 0
                                  ? "300px"
                                  : "180px"
                              }
                              height={"30px"}
                            />
                            <Skeleton width={"75px"} height={"20px"} />
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      ) : skeletonType === "deadline-list" ? (
        <div
          className="container"
          style={{
            padding: sidebars && sidebars?.length === 0 ? "0 28px" : "",
          }}
        >
          <div className="w-100 h-100">
            {details?.display_header === 1 && (
              <div style={{ height: "50px" }} className="mb-2">
                <Skeleton height={"40px"} containerClassName="w-100" />
              </div>
            )}
            <div className="d-flex flex-column gap-3 pt-2">
              {new Array(length || 3).fill("").map((item, index) => {
                return (
                  <div className="d-flex gap-2 mt-2" style={{ height: "94px" }}>
                    <div style={{ width: "75px" }}>
                      <Skeleton containerClassName="w-100" height="64px" />
                    </div>
                    <div className="w-100">
                      <Skeleton
                        width={
                          sidebars && sidebars?.length === 0 ? "450px" : "300px"
                        }
                        height="24px"
                      />
                      <Skeleton width={"100px"} height="18px" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : skeletonType === "navbar" ? (
        <div
          className="w-100 d-flex align-items-center justify-content-center"
          style={{ height: "85px" }}
        >
          <div className="d-flex align-items-center justify-content-center gap-3">
            <div className="d-flex justify-content-center align-items-center gap-3">
              {new Array(6).fill("").map((item, index) => {
                return (
                  <Skeleton key={"index"} width={"85px"} height={"25px"} />
                );
              })}
            </div>
            <Skeleton width={"25px"} height={"25px"} />
          </div>
        </div>
      ) : skeletonType === "footer" ? (
        <div className="w-100" style={{ height: "50px" }}>
          <Skeleton containerClassName="w-100 px-4" height="25px" />
        </div>
      ) : null}
    </div>
  );
};

export default SkeletonLoader;
